import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Decor_auth.png'


const _withScopeId = n => (_pushScopeId("data-v-953f0b2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view auth" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "auth__decor",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "auth__slide" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "auth__title" }, "Авторизация", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "auth__text" }, " Создайте новый аккаунт или войдите в существующий! ", -1))
const _hoisted_6 = {
  key: 0,
  class: "auth__error"
}
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button button-md button-light"
}, " Войти в Burngram ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "auth__small" }, [
  /*#__PURE__*/_createTextVNode(" Нажимая на кнопку, вы соглашаетесь с "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://871128.selcdn.ru/docs/personal-data-policy.pdf",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " политикой конфиденциальности "),
  /*#__PURE__*/_createTextVNode(" и с "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://drive.google.com/file/d/1vip5X3DTfe0XH_hC9thvoBulcBdktToh/view?usp=sharing",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " условиями использования платформы "),
  /*#__PURE__*/_createTextVNode(" . ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Телефон", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Чтобы получить n-burn на свой баланс "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" заполните поле с телефоном ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Введите код", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Почта", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Чтобы получить n-burn на свой баланс "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" заполните поле с телефоном ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Введите код", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Телеграм", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Чтобы получить n-burn на свой баланс "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" заполните поле с ником в телеграм ")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Вконтакте", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Чтобы получить n-burn на свой баланс "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" авторизуйтесь через вк ")
], -1))

import { Ref, ref } from 'vue';
import { useRouter } from 'vue-router';
import BaseField from '@/components/shared/BaseField.vue';
import BaseSlider from '@/components/shared/BaseSlider.vue';
import { AuthService } from '@/services/AuthService';
import { OnboardSevice } from '@/services/OnboardService';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthView',
  setup(__props) {

const router = useRouter();

const email: Ref<string> = ref('');
const password: Ref<string> = ref('');

const state: Ref<'none' | 'loading' | 'error'> = ref('none');
async function doAuth() {
	state.value = 'loading';
	const resp = await AuthService.authorize(email.value, password.value);

	if (resp.result === true) {
		// Old account
		if (resp.created === false) {
			OnboardSevice.welcomeState = { finished: true };
			OnboardSevice.onboardTabsState = { finished: true };
			OnboardSevice.onboardTourState = { finished: true, step: 8 };
		}
		// New account
		else {
			OnboardSevice.welcomeState = { finished: false };
			OnboardSevice.onboardTabsState = { finished: false };
			OnboardSevice.onboardTourState = { finished: false, step: 0 };
		}

		router.push('/');
	} else {
		state.value = 'error';
	}
}
/*
async function doAuthAnonymous() {
	await AuthService.authorizeAnonymous();
	router.push("/");
}
*/

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(BaseSlider, {
      onFinish: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/register'))),
      slides: 1,
      "use-toggle": false,
      "use-next-button": false
    }, {
      "1": _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          (state.value === 'error')
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Почта или же пароль были неверными, попробуйте ещё раз. "))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _withModifiers(doAuth, ["prevent"])
          }, [
            _createVNode(BaseField, {
              value: email.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              type: "email",
              required: true,
              placeholder: "Введите эл. почту"
            }, null, 8, ["value"]),
            _createVNode(BaseField, {
              value: password.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              type: "password",
              required: true,
              placeholder: "Введите пароль"
            }, null, 8, ["value"]),
            _hoisted_8,
            _hoisted_9
          ], 40, _hoisted_7)
        ])
      ]),
      "2": _withCtx(() => [
        _hoisted_10,
        _hoisted_11
      ]),
      "3": _withCtx(() => [
        _hoisted_12
      ]),
      "4": _withCtx(() => [
        _hoisted_13,
        _hoisted_14
      ]),
      "5": _withCtx(() => [
        _hoisted_15
      ]),
      "6": _withCtx(() => [
        _hoisted_16,
        _hoisted_17
      ]),
      "7": _withCtx(() => [
        _hoisted_18,
        _hoisted_19
      ]),
      _: 1
    })
  ]))
}
}

})